<ng-container *ngIf="advertisementImage">
  <img
    loading="lazy"
    src="{{ advertisementImage }}"
    class="rounded-lg {{ imgClass }} aspect-[21/10] cursor-pointer"
    (click)="openInNewTab(advertisementImageUrl)"
    (error)="replaceWithDefaultImage($event)" 
  />
</ng-container>
